import Draggable from 'react-draggable';
import { tempHandleDeviceDrop } from './WidgetDropFunction';
import { handleDeviceMenu } from './WidgetContentMenuFunction';
import styles from '../NewPage.module.css';
import {
  DeviceController,
  DeviceDisplay,
  DeviceEnergyMeter,
  DeviceFlowMeter,
  DeviceIO,
  Devices,
} from '../Devices';
import motorgif from '../../../../../../assets/motorgif.gif';
import { LineChart } from '../LineChart';
import { PieChart } from '../PieChart';
import { BarChart } from '../BarChart';
import { Histogram } from '../Histogram';
import { Gauge } from '../Gauge';
import { ProgressBar } from '../ProgressBar';
import { ToolBarGrid } from '../ToolBarGrid';
import { MovableTable } from 'components/MovableTable/MovableTable';
import { handleDoubleClick } from './WidgetDoubleClickFunction';
import { CircularProgressChart } from '../CircularProgress';
import { DoughnutChart } from '../DoughnutChart';
import { Stage, Layer, Line } from 'react-konva';
import { useEffect, useRef, useState } from 'react';
import CustomSwitch from './components/CustomSwitch';
import { Slider } from './components/Slider';
import LampON from "../../../../../../assets/LampON.svg";
import LampOFF from "../../../../../../assets/LampOFF.svg";
import Clock from './components/Clock';
import { border } from '@chakra-ui/react';
import BulbIcon from 'components/BulbIcon';

function formatFromSeconds(sec) {
  const d = Math.floor(sec / 86400);
  const h = Math.floor((sec % 86400) / 3600);
  const m = Math.floor((sec % 3600) / 60);

  return `${d}d ${h}h ${m}m`;
}


export const TempGenerateDevice = ({
  tempTabIndexDevices,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexDevices,
  indicatorRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setIsDeviceMenu,
  setCurrentDevice,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  openNewPage,
  pvSpecificChannel,
  tableData,
  clickedDeviceIndex,
  selectedDevice,
  currentPVChannel,
  isMobile,
}) => {
  const selectedTabDevices = tempTabIndexDevices[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, name, channelName, id, deviceType, unit, zIndex } = device;

      const deviceStyle = {
        backgroundColor: 'rgb(20, 17, 15)',
        width: '20%',
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        borderRadius: '0.625rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        padding: '0.6rem',
        zIndex: zIndex ? zIndex : "1"
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexDevices,
              setUpdatedTabIndexDevices,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (indicatorRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
              })
            }
            className={styles.addImg}
          >
            <Devices
              name={name}
              openNewPage={openNewPage}
              pvSpecificChannel={pvSpecificChannel}
              tableData={tableData}
              channelName={channelName.PV}
              tempTabIndexDevices={tempTabIndexDevices}
              clickedDeviceIndex={clickedDeviceIndex}
              selectedDevice={selectedDevice}
              activeTabIndex={activeTabIndex}
              currentPVChannel={currentPVChannel}
              unit={unit}
              index={index}
              tempImages={tempImages}
              setTempImages={setTempImages}
              id={id}
              isMobile={isMobile}
            />
          </div>
        </Draggable>
      );
    });
  }

}

export const TempGenerateDisplay = ({
  tempTabIndexDisplay,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexDisplay,
  displayRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setIsDeviceMenu,
  setCurrentDevice,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexDisplay,
  multipleDisplay,
  setMultipleDisplay,
  openNewPage,
  tableData,
}) => {
  const selectedTabDevices = tempTabIndexDisplay[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const {
        x,
        y,
        channelName,
        id,
        deviceType,
        width,
        height,
        bgColor,
        textColor,
        fontSize,
        zIndex,
      } = device;

      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        borderRadius: '0.625rem',
        backgroundColor: bgColor,
        padding: '0.6rem 1rem',
        color: textColor,
        fontSize: fontSize ? fontSize + 'px' : '30px',
        width: width ? width : '12%',
        height: height ? height : undefined,
        resize: 'both',
        zIndex: zIndex ? zIndex : '1',
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexDisplay,
              setUpdatedTabIndexDisplay,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (displayRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexDisplay,
                updatedTabIndexDisplay,
                setUpdatedTabIndexDisplay,
                multipleDisplay,
                setMultipleDisplay,
                bgColor,
                textColor,
                fontSize,
              })
            }
            className={styles.addImg}
            id={`display-${index}`}
          >
            <DeviceDisplay
              openNewPage={openNewPage}
              tableData={tableData}
              channelName={channelName.PV}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateController = ({
  tempTabIndexController,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexController,
  controllerRefs,
  setCurrentDevice,
  setIsDeviceMenu,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  images,
  openNewPage,
  tabIndexController,
  setTempTabIndexController,
  clickedDeviceIndex,
  selectedDevice,
  tableData,
  currentPVController,
  pvSpecificChannel,
  currentSVContoller,
  isMobile,
  vNetUsername,
  comid,
  compvtkey,
  vNetPassword,
  key,
  dispatch,
  setLoginSid,
  setIsChangeSV,
  tempTabIndexIO,
  setUpdatedTabIndexIO,
  setTempTabIndexIO,
}) => {
  const selectedTabDevices = tempTabIndexController[activeTabIndex];

  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, name, channelName, tabIndex, id, deviceType, unit, zIndex } =
        device;
      const deviceStyle = {
        backgroundColor: 'rgb(20, 17, 15)',
        width: '20%',
        position: 'absolute',
        zIndex: zIndex ? zIndex : "1",
        top: y + 'px',
        left: x + 'px',
        borderRadius: '0.625rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        padding: '0.6rem',
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexController,
              activeTabIndex,
              tempTabIndexController,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (controllerRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setCurrentDevice,
                setIsDeviceMenu,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
              })
            }
            className={styles.addImg}
            // onDoubleClick={(e) =>
            //   handleDoubleClick(e, deviceType, {
            //     id,
            //     vNetUsername,
            //     comid,
            //     compvtkey,
            //     vNetPassword,
            //     key,
            //     dispatch,
            //     setLoginSid,
            //     setSelectedDeviceId,
            //     setCurrentDevice,
            //     setIsChangeSV,
            //     tempImages,
            //     setTempImages,
            //     setUpdatedImages,
            //     tempTabIndexIO,
            //     activeTabIndex,
            //     setUpdatedTabIndexIO,
            //     setTempTabIndexIO,
            //   })
            // }
          >
            <DeviceController
              images={images}
              name={name}
              openNewPage={openNewPage}
              tabIndexController={tabIndexController}
              tempTabIndexController={tempTabIndexController}
              setTempTabIndexController={setTempTabIndexController}
              activeTabIndex={activeTabIndex}
              clickedDeviceIndex={clickedDeviceIndex}
              selectedDevice={selectedDevice}
              tableData={tableData}
              pvSpecificChannel={pvSpecificChannel}
              channelName={channelName}
              deviceType={deviceType}
              currentPVChannel={currentPVController}
              currentSVChannel={currentSVContoller}
              unit={unit}
              index={index}
              id={id}
              tabIndex={tabIndex}
              isMobile={isMobile}
              tempImages={tempImages}
              setTempImages={setTempImages}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateIO = ({
  tempTabIndexIO,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexIO,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  ioRefs,
  openNewPage,
  tabIndexController,
  clickedDeviceIndex,
  selectedDevice,
  tableData,
  updatedTabIndexIO,
  setMultipleIO,
  multipleIO
}) => {
  const selectedTabDevices = tempTabIndexIO[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, name, id, deviceType, on, width, height, onText, offText, onColor, offColor, channelName, zIndex } = device;
      const deviceStyle = {
        width: width ? width : '190px',
        height: height ? height : '160px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0.5rem',
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        resize: 'both',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexIO,
              setUpdatedTabIndexIO,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexIO,
                updatedTabIndexIO,
                setUpdatedTabIndexIO,
                setMultipleIO,
                multipleIO

              })
            }
            ref={(el) => (ioRefs.current[index] = el)}
            className={styles.addImg}
            id={`digitalio-${index}`}


          //   onDoubleClick={(e) => handleDoubleClick(e, deviceType, id, on)}
          >
            <DeviceIO
              name={name}
              openNewPage={openNewPage}
              tabIndexController={tabIndexController}
              activeTabIndex={activeTabIndex}
              clickedDeviceIndex={clickedDeviceIndex}
              selectedDevice={selectedDevice}
              tableData={tableData}
              deviceType={deviceType}
              on={on}
              onText={onText}
              offText={offText}
              onColor={onColor}
              offColor={offColor}
              channelName={channelName}


            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateFlowMeter = ({
  tempTabIndexFlowM,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexFlowM,
  flowMRefs,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  openNewPage,
  images,
  clickedDeviceIndex,
  selectedDevice,
  tableData,
  pvSpecificChannel,
  currentPVFlowM,
  currentSVFlowM,
  isMobile,
}) => {
  const selectedTabDevices = tempTabIndexFlowM[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, name, channelName, id, deviceType, unitPv, unitSv, zIndex } =
        device;
      const deviceStyle = {
        backgroundColor: 'rgb(20, 17, 15)',
        width: '25%',
        position: 'absolute',
        zIndex: zIndex ? zIndex : "1",
        top: y + 'px',
        left: x + 'px',
        borderRadius: '0.625rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        padding: '0.6rem',
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexFlowM,
              activeTabIndex,
              tempTabIndexFlowM,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (flowMRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
              })
            }
            className={styles.addImg}
          >
            <DeviceFlowMeter
              name={name}
              openNewPage={openNewPage}
              tempTabIndexFlowM={tempTabIndexFlowM}
              index={index}
              unitPv={unitPv}
              unitSv={unitSv}
              images={images}
              activeTabIndex={activeTabIndex}
              clickedDeviceIndex={clickedDeviceIndex}
              selectedDevice={selectedDevice}
              tableData={tableData}
              pvSpecificChannel={pvSpecificChannel}
              channelName={channelName}
              deviceType={deviceType}
              currentPVChannel={currentPVFlowM}
              currentSVChannel={currentSVFlowM}
              id={id}
              isMobile={isMobile}
              tempImages={tempImages}
              setTempImages={setTempImages}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateEnergyNeter = ({
  tempTabIndexEnergyM,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexEnergyM,
  energyMRefs,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  openNewPage,
  images,
  clickedDeviceIndex,
  selectedDevice,
  tableData,
  pvSpecificChannel,
  currentPVEnergyM,
  currentSVEnergyM,
}) => {
  const selectedTabDevices = tempTabIndexEnergyM[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const {
        x,
        y,
        name,
        channelName,
        id,
        deviceType,
        unitPv,
        unitSv,
        unitSv2,
        unitSv3,
        zIndex,
      } = device;
      const deviceStyle = {
        backgroundColor: 'rgb(20, 17, 15)',
        width: '25%',
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        borderRadius: '0.625rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        padding: '0.6rem',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexEnergyM,
              activeTabIndex,
              tempTabIndexEnergyM,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (energyMRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
              })
            }
            className={styles.addImg}
          >
            <DeviceEnergyMeter
              name={name}
              openNewPage={openNewPage}
              images={images}
              tempTabIndexEnergyM={tempTabIndexEnergyM}
              activeTabIndex={activeTabIndex}
              clickedDeviceIndex={clickedDeviceIndex}
              selectedDevice={selectedDevice}
              tableData={tableData}
              pvSpecificChannel={pvSpecificChannel}
              channelName={channelName}
              deviceType={deviceType}
              currentPVChannel={currentPVEnergyM}
              currentSVChannel={currentSVEnergyM}
              index={index}
              id={id}
              unitPv={unitPv}
              unitSv={unitSv}
              unitSv2={unitSv2}
              unitSv3={unitSv3}
              tempImages={tempImages}
              setTempImages={setTempImages}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateMotor = ({
  tempTabIndexMotor,
  activeTabIndex,
  isMobile,
  scaleValue,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexMotor,
  motorRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setIsDeviceMenu,
  setCurrentDevice,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexMotor,
  multipleMotor,
  setMultipleMotor,
}) => {
  const selectedTabImages = tempTabIndexMotor[activeTabIndex];
  if (Array.isArray(selectedTabImages)) {
    return selectedTabImages.map((device, index) => {
      const { x, y, width, height, name, id, deviceType, zIndex } = device;
      const imageStyle = {
        display: 'flex',
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        width: width ? width : '250px',
        height: height ? height : '150px',
        scale: isMobile ? scaleValue.toString() : '1',
        resize: 'both',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexMotor,
              activeTabIndex,
              tempTabIndexMotor,
            })
          }
        >
          <div
            style={imageStyle}
            key={index}
            className={styles.addImg}
            ref={(el) => (motorRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setIsDeviceMenu,
                setCurrentDevice,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexMotor,
                multipleMotor,
                setMultipleMotor,
                tempTabIndexMotor,
                setUpdatedTabIndexMotor,
              })
            }
            id={`motor-${index}`}
          >
            {device.on ? (
              <img src={motorgif} alt="MotorImg" />
            ) : (
              <img src={name} alt="MotorImg" />
            )}
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateText = ({
  tempTabIndexText,
  activeTabIndex,
  isMobile,
  scaleValue,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexText,
  textRefs,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexText,
  multipleText,
  setMultipleText,
  tableData
}) => {
  const selectedTabDevices = tempTabIndexText[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {

      const {
        x,
        y,
        id,
        deviceType,
        width,
        height,
        bgColor,
        textColor,
        text,
        fontSize,
        alignHorizontally,
        alignVertically,
        channelName,
        isTransparent,
        zIndex
      } = device;

      const channel = tableData.find((data) => data.Header === channelName?.PV);
      let statusVal;

      if (channel) {
        if (channel.Header.includes("Event_")) {

          statusVal = formatFromSeconds(channel?.val)

        } else {
          statusVal = channel?.val;

        }

      } else {

        statusVal = text;

      }

      
      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        backgroundColor: isTransparent ? "transparent" : bgColor,
        color: textColor,
        padding: '0.6rem 1rem',
        fontSize: fontSize ? fontSize + 'px' : '30px',
        width: width ? width : undefined,
        height: height ? height : undefined,
        scale: isMobile ? scaleValue.toString() : '1',
        resize: 'both',
        display: 'flex',
        wordBreak: 'break-word',
        justifyContent: alignHorizontally ? alignHorizontally : 'start',
        alignItems: alignVertically ? alignVertically : 'start',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexText,
              activeTabIndex,
              tempTabIndexText,
            })
          }
        >
          <div
            style={deviceStyle}
            className={styles.addImg}
            ref={(el) => (textRefs.current[index] = el)}
            key={index}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                bgColor,
                textColor,
                fontSize,
                text,
                alignVertically,
                alignHorizontally,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexText,
                multipleText,
                setMultipleText,
                tempTabIndexText,
                setUpdatedTabIndexText,
              })
            }
            id={`text-${index}`}
          >
            {statusVal}
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateLineChart = ({
  tempTabIndexLineChart,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexLineChart,
  lineChartRefs,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexLineChart,
  multipleLineCharts,
  setMultipleLineCharts,
  dateTimesLive,
  channelNames,
  dataArrLive,
  getRandomColor,
  tabIndexBarChart,
  openNewPage,
  selectedDevice,
  clickedDeviceIndex,
  data,
  oneDayDataTs,
}) => {
  const selectedTabDevices = tempTabIndexLineChart[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, chartChannel, width, height, hour, minute, zIndex, lineStyle, isCurveLine, isSteppedLine, minY, maxY, xInterval,
        yInterval } =
        device;



      const updatedWidth = updatedTabIndexLineChart[activeTabIndex][index].width;
      const updatedHeight = updatedTabIndexLineChart[activeTabIndex][index].height ? updatedTabIndexLineChart[activeTabIndex][index].height : height;


      const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));

      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        backgroundColor: '#fff',
        width: updatedWidth ? updatedWidth : '40%',
        height: updatedHeight ? updatedHeight : "auto",
        resize: 'both',
        borderRadius: '.625rem',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexLineChart,
              activeTabIndex,
              updatedTabIndexLineChart,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (lineChartRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexLineChart,
                multipleLineCharts,
                setMultipleLineCharts,
                tempTabIndexLineChart,
                setUpdatedTabIndexLineChart,
              })
            }
            className={styles.addImg}
            id={`linechart-${index}`}
          >
            <LineChart
              dateTimesLive={dateTimesLive}
              channelNames={channelNames}
              dataArrLive={filteredDataArrLive}
              getRandomColor={getRandomColor}
              chartChannel={chartChannel}
              tabIndexBarChart={tabIndexBarChart}
              selectedTabIndex={activeTabIndex}
              openNewPage={openNewPage}
              selectedDevice={selectedDevice}
              clickedDeviceIndex={clickedDeviceIndex}
              data={data}
              hour={hour}
              minute={minute}
              oneDayDataTs={oneDayDataTs}
              lineStyle={lineStyle}
              isCurveLine={isCurveLine}
              isSteppedLine={isSteppedLine}
              minY={minY}
              maxY={maxY}
              xInterval={xInterval}
              yInterval={yInterval}
              width={updatedWidth}
              height={updatedHeight}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGeneratePieChart = ({
  tempTabIndexPieChart,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexPieChart,
  pieChartRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setIsDeviceMenu,
  setCurrentDevice,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexPieChart,
  multiplePieChart,
  setMultiplePieChart,
  dateTimesLive,
  channelNames,
  dataArrLive,
  getRandomColor,
  tabIndexPieChart,
  openNewPage,
  selectedDevice,
  clickedDeviceIndex,
}) => {
  const selectedTabDevices = tempTabIndexPieChart[activeTabIndex];

  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, chartChannel, width, zIndex } = device;
      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        resize: 'both',
        zIndex: zIndex ? zIndex : "1",
        width: width ? width : '27%',
      };

      const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexPieChart,
              activeTabIndex,
              tempTabIndexPieChart,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (pieChartRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setIsDeviceMenu,
                setCurrentDevice,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexPieChart,
                multiplePieChart,
                setMultiplePieChart,
                tempTabIndexPieChart,
                setUpdatedTabIndexPieChart,
              })
            }
            className={styles.addImg}
            id={`piechart-${index}`}
          >
            <PieChart
              dateTimesLive={dateTimesLive}
              channelNames={channelNames}
              dataArrLive={filteredDataArrLive}
              getRandomColor={getRandomColor}
              chartChannel={chartChannel}
              tabIndexPieChart={tabIndexPieChart}
              selectedTabIndex={activeTabIndex}
              openNewPage={openNewPage}
              selectedDevice={selectedDevice}
              clickedDeviceIndex={clickedDeviceIndex}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateBarChart = ({
  tempTabIndexBarChart,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexBarChart,
  barChartRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setIsDeviceMenu,
  setCurrentDevice,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexBarChart,
  multipleBarChart,
  setMultipleBarChart,
  dateTimesLive,
  channelNames,
  dataArrLive,
  getRandomColor,
  setBarChartData,
  tabIndexBarChart,
  barChartData,
  openNewPage,
  selectedDevice,
  clickedDeviceIndex,
}) => {
  const selectedTabDevices = tempTabIndexBarChart[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, chartChannel, width, zIndex } = device;

      const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));

      const deviceStyle = {
        backgroundColor: '#fff',
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        width: width ? width : '40%',
        resize: 'both',
        borderRadius: '.625rem',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexBarChart,
              activeTabIndex,
              tempTabIndexBarChart,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (barChartRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setIsDeviceMenu,
                setCurrentDevice,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexBarChart,
                multipleBarChart,
                setMultipleBarChart,
                tempTabIndexBarChart,
                setUpdatedTabIndexBarChart,
              })
            }
            className={styles.addImg}
            id={`barchart-${index}`}
          >
            <BarChart
              dateTimesLive={dateTimesLive}
              channelNames={channelNames}
              dataArrLive={filteredDataArrLive}
              getRandomColor={getRandomColor}
              setBarChartData={setBarChartData}
              chartChannel={chartChannel}
              tabIndexBarChart={tabIndexBarChart}
              selectedTabIndex={activeTabIndex}
              barChartData={barChartData}
              openNewPage={openNewPage}
              selectedDevice={selectedDevice}
              clickedDeviceIndex={clickedDeviceIndex}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateHistogram = ({
  tempTabIndexHistogram,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexHistogram,
  histogramRefs,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexHistogram,
  multipleHistogram,
  setMultipleHistogram,
  dateTimesLive,
  channelNames,
  dataArrLive,
  getRandomColor,
  setHistogramData,
  tabIndexBarChart,
  histogramData,
  openNewPage,
  selectedDevice,
  clickedDeviceIndex,
  oneDayDataTs,
}) => {
  const selectedTabDevices = tempTabIndexHistogram[activeTabIndex];

  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, chartChannel, width, hour, minute, zIndex } =
        device;

      const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));


      const deviceStyle = {
        backgroundColor: '#fff',
        position: 'absolute',
        zIndex: zIndex ? zIndex : "1",
        top: y + 'px',
        left: x + 'px',
        width: width ? width : '40%',
        resize: 'both',
        borderRadius: '.625rem',
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexHistogram,
              activeTabIndex,
              tempTabIndexHistogram,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (histogramRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexHistogram,
                multipleHistogram,
                setMultipleHistogram,
                tempTabIndexHistogram,
                setUpdatedTabIndexHistogram,
              })
            }
            className={styles.addImg}
            id={`histogram-${index}`}
          >
            <Histogram
              dateTimesLive={dateTimesLive}
              channelNames={channelNames}
              dataArrLive={filteredDataArrLive}
              getRandomColor={getRandomColor}
              setHistogramData={setHistogramData}
              chartChannel={chartChannel}
              tabIndexBarChart={tabIndexBarChart}
              selectedTabIndex={activeTabIndex}
              histogramData={histogramData}
              openNewPage={openNewPage}
              selectedDevice={selectedDevice}
              clickedDeviceIndex={clickedDeviceIndex}
              hour={hour}
              minute={minute}
              oneDayDataTs={oneDayDataTs}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateGauge = ({
  tempTabIndexGauge,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexGauge,
  gaugeRefs,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexGauge,
  multipleGauge,
  setMultipleGauge,
  dateTimesLive,
  channelNames,
  dataArrLive,
  getRandomColor,
  tabIndexBarChart,
  openNewPage,
  selectedDevice,
  clickedDeviceIndex,
  specificMaxVal,
  specificMinVal,
  changeRange,
}) => {
  const selectedTabDevices = tempTabIndexGauge[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const {
        x,
        y,
        id,
        deviceType,
        chartChannel,
        minVal,
        maxVal,
        width,
        height,
        fontSize,
        zIndex,
      } = device;

      const chartChannelArray =
        typeof chartChannel === 'string' ? [chartChannel] : chartChannel;

      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        width: width ? width : '20%',
        height: height,
        resize: 'both',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexGauge,
              activeTabIndex,
              tempTabIndexGauge,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (gaugeRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexGauge,
                multipleGauge,
                setMultipleGauge,
                tempTabIndexGauge,
                setUpdatedTabIndexGauge,
              })
            }
            className={styles.addImg}
            id={`gauge-${index}`}
          >
            <Gauge
              dateTimesLive={dateTimesLive}
              channelNames={channelNames}
              dataArrLive={dataArrLive}
              getRandomColor={getRandomColor}
              chartChannel={chartChannelArray}
              tabIndexBarChart={tabIndexBarChart}
              selectedTabIndex={activeTabIndex}
              openNewPage={openNewPage}
              selectedDevice={selectedDevice}
              clickedDeviceIndex={clickedDeviceIndex}
              minVal={minVal}
              maxVal={maxVal}
              specificMaxVal={specificMaxVal}
              specificMinVal={specificMinVal}
              changeRange={changeRange}
              fontSize={fontSize}
              id={id}
            />
          </div>
        </Draggable>
      );
    });
  }

}

export const TempGenerateProgressBar = ({
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  tempTabIndexProgress,
  updatedTabIndexProgress,
  setUpdatedTabIndexProgress,
  multipleProgress,
  setMultipleProgress,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  progressBarRefs,
  dateTimesLive,
  channelNames,
  dataArrLive,
  getRandomColor,
  tabIndexBarChart,
  openNewPage,
  selectedDevice,
  clickedDeviceIndex,
}) => {
  const selectedTabDevices = tempTabIndexProgress[activeTabIndex];

  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const {
        x,
        y,
        id,
        deviceType,
        chartChannel,
        minVal,
        maxVal,
        rotate,
        width,
        height,
        fontSize,
        bgColor,
        zIndex,
      } = device;

      const chartChannelArray =
        typeof chartChannel === 'string' ? [chartChannel] : chartChannel;

      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        display: rotate ? 'flex' : null,
        justifyContent: rotate ? 'center' : null,
        alignItems: rotate ? 'center' : null,
        height: height ? height : '',
        width: width ? width : '20%',
        resize: 'both',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexProgress,
              setUpdatedTabIndexProgress,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (progressBarRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexProgress,
                updatedTabIndexProgress,
                setUpdatedTabIndexProgress,
                multipleProgress,
                setMultipleProgress,
              })
            }
            className={styles.addImg}
            id={`progressbar-${index}`}
          >
            <ProgressBar
              dateTimesLive={dateTimesLive}
              channelNames={channelNames}
              dataArrLive={dataArrLive}
              getRandomColor={getRandomColor}
              chartChannel={chartChannelArray}
              tabIndexBarChart={tabIndexBarChart}
              selectedTabIndex={activeTabIndex}
              openNewPage={openNewPage}
              selectedDevice={selectedDevice}
              clickedDeviceIndex={clickedDeviceIndex}
              minVal={minVal}
              maxVal={maxVal}
              rotate={rotate}
              bgColor={bgColor}
              fontSize={fontSize}

            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateGrid = ({
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  tempTabIndexGrid,
  updatedTabIndexGrid,
  setUpdatedTabIndexGrid,
  multipleGrid,
  setMultipleGrid,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  gridRefs,
  tableData,
}) => {
  const selectedTabDevices = tempTabIndexGrid[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, chartChannel, width, height, zIndex } = device;

      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        resize: 'both',
        width: width ? width : 'auto',
        height: height ? height : 'auto',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexGrid,
              setUpdatedTabIndexGrid,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (gridRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexGrid,
                updatedTabIndexGrid,
                setUpdatedTabIndexGrid,
                multipleGrid,
                setMultipleGrid,
              })
            }
            className={styles.addImg}
            id={`grid-${index}`}
          >
            <ToolBarGrid tableData={tableData} chartChannel={chartChannel} />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateTable = ({
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  tempTabIndexTable,
  updatedTabIndexTable,
  setUpdatedTabIndexTable,
  multipleTable,
  setMultipleTable,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  tableRefs,
  dateTimesLive,
  dataArrLive,
  channelNames,
  getRandomColor,
  tabIndexBarChart,
  openNewPage,
  selectedDevice,
  clickedDeviceIndex,
}) => {
  const selectedTabDevices = tempTabIndexTable[activeTabIndex];

  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, deviceType, id, width, chartChannel, column, height, zIndex } =
        device;
      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        resize: 'both',
        width: width ? width : 'auto',
        height: height ? height : 'auto',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexTable,
              setUpdatedTabIndexTable,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (tableRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexTable,
                updatedTabIndexTable,
                setUpdatedTabIndexTable,
                multipleTable,
                setMultipleTable,
              })
            }
            className={styles.addImg}
            id={`table-${index}`}
          >
            <MovableTable
              dateTimesLive={dateTimesLive}
              channelNames={channelNames}
              dataArrLive={dataArrLive}
              getRandomColor={getRandomColor}
              tabIndexBarChart={tabIndexBarChart}
              selectedTabIndex={activeTabIndex}
              openNewPage={openNewPage}
              selectedDevice={selectedDevice}
              clickedDeviceIndex={clickedDeviceIndex}
              chartChannel={chartChannel}
              column={column}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateCircularProgress = ({
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  tempTabIndexCircularProgress,
  updatedTabIndexCircularProgress,
  setUpdatedTabIndexCircularProgress,
  multipleCircularProgress,
  setMultipleCircularProgress,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  circularProgressRefs,
  circularProgressData,
  dateTimesLive,
  dataArrLive,
}) => {
  const selectedTabDevices = tempTabIndexCircularProgress[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, chartChannel, width, height, maxVal, zIndex } =
        device;

      const deviceStyle = {
        position: 'absolute',
        left: x + 'px',
        top: y + 'px',
        padding: '.2rem',
        resize: 'both',
        width: width ? width : '100px',
        height: height ? height : '100px',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexCircularProgress,
              setUpdatedTabIndexCircularProgress,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (circularProgressRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexCircularProgress,
                updatedTabIndexCircularProgress,
                setUpdatedTabIndexCircularProgress,
                multipleCircularProgress,
                setMultipleCircularProgress,
              })
            }
            className={styles.addImg}
            id={`circularprogress-${index}`}
          >
            <CircularProgressChart
              progress={60}
              chartChannel={chartChannel}
              dateTimesLive={dateTimesLive}
              dataArrLive={dataArrLive}
              maxVal={maxVal}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateDoughnutChart = ({
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  tempTabIndexDoughnut,
  updatedTabIndexDoughnut,
  setUpdatedTabIndexDoughnut,
  multipleDoughnut,
  setMultipleDoughnut,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  doughnutRefs,
  dateTimesLive,
  dataArrLive,
  getRandomColor,
}) => {
  const selectedTabDevices = tempTabIndexDoughnut[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, chartChannel, width, height, zIndex } = device;

      const deviceStyle = {
        position: 'absolute',
        left: x + 'px',
        top: y + 'px',
        resize: 'both',
        width: width ? width : '150px',
        height: height ? height : '150px',
        zIndex: zIndex ? zIndex : "1",
      };

      const filteredDataArrLive = dataArrLive.filter((dataset) => !dataset.label.includes("Event_"));


      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexDoughnut,
              setUpdatedTabIndexDoughnut,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (doughnutRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexDoughnut,
                updatedTabIndexDoughnut,
                setUpdatedTabIndexDoughnut,
                multipleDoughnut,
                setMultipleDoughnut,
              })
            }
            className={styles.addImg}
            id={`doughnut-${index}`}
          >
            <DoughnutChart
              chartChannel={chartChannel}
              dataArrLive={filteredDataArrLive}
              getRandomColor={getRandomColor}
            />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateLines = ({
  tempTabIndexLines,
  selectedTabIndex,
  isMobile,
  scaleValue,
  lineRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  setUpdatedTabIndexLines,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  tableData

}) => {
  const selectedTabImages = tempTabIndexLines[selectedTabIndex];
  if (Array.isArray(selectedTabImages)) {
    return selectedTabImages.map((line, index) => {
      const { x, y, width, angle, deviceType, id, height, zIndex, bgColor, deltaX, deltaY, length } = line;


      // const imageStyle = {
      //   position: 'absolute',
      //   top: y + 'px',
      //   left: x + 'px',
      //   width: width + 'px',
      //   height: '2px',
      //   backgroundColor: bgColor ? bgColor : 'black',
      //   scale: isMobile ? scaleValue.toString() : '1',
      //   // transformOrigin: '0 0',
      //   rotate: `${line.angle}deg`,
      //   zIndex: zIndex ? zIndex : "1",
      // };

      return (
        <Draggable
          key={index}
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              tempTabIndexLines,
              setUpdatedTabIndexLines,
            })
          }
        >
          <div
            style={{
              position: "absolute",
              top: `${y}px`,
              left: `${x}px`,
              width: `${Number(width) + 3}px`,
              height: `${Number(height) + 3}px`,
              zIndex: zIndex ? zIndex : "1",
            }}
            className={styles.addImg}
            ref={(el) => (lineRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, line, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
              })
            }
          >


            <div
              style={{
                position: "absolute",

                left: deltaX >= 0 ? 0 : Math.abs(deltaX),
                top: deltaY >= 0 ? 0 : Math.abs(deltaY),

                width: `${length}px`,
                height: "2px",
                backgroundColor: bgColor ? bgColor : "black",

                transformOrigin: "0 0",
                transform: `rotate(${angle}deg)`,

              }}
              key={index}

              className={styles.addImg}
            ></div>
          </div>

        </Draggable>

      );
    });
  }
};

export const TempGenerateSquare = ({
  tempTabIndexSquare,
  selectedTabIndex,
  squareRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexSquare,
  setUpdatedTabIndexSquare,
  multipleSquare,
  setMultipleSquare,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  tableData
}) => {
  const selectedTabImages = tempTabIndexSquare[selectedTabIndex];
  if (Array.isArray(selectedTabImages)) {
    return selectedTabImages.map((square, index) => {
      const { id, deviceType, onText, offText, text, onColor, offColor, fontSize, bgColor, channelName, width, height, x, y, textColor, zIndex, borderRadius } = square;



      const channel = tableData.find((data) => data.Header === channelName?.PV);

      let statusText;
      let statusColor;

      if (channel) {
        if (channel?.val === 1) {
          statusText = onText;
          statusColor = onColor
        } else if (channel?.val === 0) {
          statusText = offText;
          statusColor = offColor
        } else {
          statusText = text;
          statusColor = bgColor;
        }
      } else {
        statusText = text;
        statusColor = bgColor;
      }
      const deviceStyle = {
        width: width ? width : '100px',
        height: height ? height : '100px',
        position: 'absolute',
        left: x ? x : '0px',
        top: y ? y : '40px',
        border: '1px solid black',
        background: statusColor ? statusColor : "white",
        resize: "both",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: fontSize ? fontSize + "px" : "14px",
        color: textColor ? textColor : "black",
        borderRadius: `${borderRadius?.toString()}%` ? `${borderRadius?.toString()}%` : "none",
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexSquare,
              setUpdatedTabIndexSquare,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (squareRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, square, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexSquare,
                updatedTabIndexSquare,
                setUpdatedTabIndexSquare,
                multipleSquare,
                setMultipleSquare,
              })
            }
            className={styles.addImg}
            id={`square-${index}`}
          >{statusText}</div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateCircle = ({
  tempTabIndexCircle,
  selectedTabIndex,
  circleRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexCircle,
  setUpdatedTabIndexCircle,
  multipleCircle,
  setMultipleCircle,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  tableData
}) => {
  const selectedTabImages = tempTabIndexCircle[selectedTabIndex];
  if (Array.isArray(selectedTabImages)) {
    return selectedTabImages.map((circle, index) => {


      const { id, deviceType, onText, offText, text, onColor, offColor, fontSize, bgColor, channelName, width, height, x, y, textColor, zIndex } = circle;

      const channel = tableData.find((data) => data.Header === channelName?.PV);



      let statusText;
      let statusColor;

      if (channel) {
        if (channel?.val === 1) {
          statusText = onText;
          statusColor = onColor
        } else if (channel?.val === 0) {
          statusText = offText;
          statusColor = offColor
        } else {
          statusText = text;
          statusColor = bgColor;
        }
      } else {
        statusText = text;
        statusColor = bgColor;
      }

      const deviceStyle = {
        width: width ? width : '100px',
        height: height ? height : '100px',
        position: 'absolute',
        left: x ? x : '0px',
        top: y ? y : '40px',
        border: '1px solid black',
        background: statusColor ? statusColor : "white",
        borderRadius: '50%',
        resize: 'both',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: textColor ? textColor : "black",
        fontSize: fontSize ? fontSize + "px" : "14px",
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexCircle,
              setUpdatedTabIndexCircle,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (circleRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, circle, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexCircle,
                updatedTabIndexCircle,
                setUpdatedTabIndexCircle,
                multipleCircle,
                setMultipleCircle,
              })
            }
            className={styles.addImg}
            id={`circle-${index}`}
          >{statusText}</div>
        </Draggable>
      );
    });
  }
};

export const TempGeneratePolygone = ({
  tempTabIndexPolygone,
  setTempTabIndexPolygone,
  selectedTabIndex,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexPolygone,
  setUpdatedTabIndexPolygone,
  multiplePolygone,
  setMultiplePolygone,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
}) => {
  const selectedTabImages = tempTabIndexPolygone[selectedTabIndex];
  if (Array.isArray(selectedTabImages)) {
    return selectedTabImages.map((polygone, index) => {
      const { id } = polygone;

      return (
        <ResizablePolygonWidget
          id={id}
          index={index}
          setSelectedDeviceId={setSelectedDeviceId}
          setDeviceMenuPosition={setDeviceMenuPosition}
          setClickedDeviceIndex={setClickedDeviceIndex}
          setIsDeviceMenu={setIsDeviceMenu}
          setSelectedDevice={setSelectedDevice}
          setCurrentDevice={setCurrentDevice}
          tempImages={tempImages}
          activeTabIndex={activeTabIndex}
          setTempImages={setTempImages}
          setUpdatedImages={setUpdatedImages}
          setAddedText={setAddedText}
          setBgColor={setBgColor}
          setTextBgColor={setTextBgColor}
          setTextColor={setTextColor}
          setWidgetTextColor={setWidgetTextColor}
          setFontSize={setFontSize}
          setTextFontSize={setTextFontSize}
          setTextAlignVertically={setTextAlignVertically}
          setTextAlignHorizontally={setTextAlignHorizontally}
          tempTabIndexPolygone={tempTabIndexPolygone}
          updatedTabIndexPolygone={updatedTabIndexPolygone}
          setUpdatedTabIndexPolygone={setUpdatedTabIndexPolygone}
          multiplePolygone={multiplePolygone}
          setMultiplePolygone={setMultiplePolygone}
          polygone={polygone}
          updatedImages={updatedImages}
          setIndexesOfDevicePosi={setIndexesOfDevicePosi}
          indexesOfDevicePosi={indexesOfDevicePosi}
        />
      );
    });
  }
};

function ResizablePolygonWidget({
  polygon,
  index,
  setPolygonePosition,
  setUpdatedMultiplePolygone,
  multiplePolygone,
  id,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  tempTabIndexPolygone,
  updatedTabIndexPolygone,
  setUpdatedTabIndexPolygone,
  setMultiplePolygone,
  polygone,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
}) {


  const containerRef = useRef(null);
  const [size, setSize] = useState({
    width: polygone?.width,
    height: polygone?.height,
  });

  const [points, setPoints] = useState([]);


  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (containerRef.current) {
        const { clientWidth, clientHeight } = containerRef.current;
        setSize({ width: clientWidth, height: clientHeight });

        const copiedTempImages = [...tempImages];


        const itemToUpdate = copiedTempImages.findIndex((item) => item.id === id);


        if (itemToUpdate !== -1) {
          const updatedItem = {
            ...copiedTempImages[itemToUpdate],
            width: clientWidth,
            height: clientHeight,
          };

          copiedTempImages[itemToUpdate] = updatedItem;
          setTempImages(copiedTempImages);
        }
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [updatedImages]);

  useEffect(() => {
    if (polygone) {


      const scaleX = size.width / polygone.width;
      const scaleY = size.height / polygone.height;

      const scaledPoints = polygone.points.map((val, i) =>
        i % 2 === 0 ? val * scaleX : val * scaleY
      )

      setPoints(scaledPoints);

      const copiedTempImages = [...tempImages];

      const itemToUpdate = copiedTempImages.findIndex((item) => item.id === id);

      if (itemToUpdate !== -1) {
        const updatedItem = {
          ...copiedTempImages[itemToUpdate],
          points: scaledPoints
        };
        copiedTempImages[itemToUpdate] = updatedItem;
        setTempImages(copiedTempImages);
      }
    }

  }, [size, updatedImages])

  return (
    <Draggable
      bounds="parent"
      onStop={(e, data) =>
        tempHandleDeviceDrop(e, data, index, id, polygone?.x, polygone?.y, polygone?.deviceType, {
          setClickedDeviceIndex,
          setSelectedDevice,
          tempImages,
          updatedImages,
          setIndexesOfDevicePosi,
          indexesOfDevicePosi,
          setTempImages,
          setUpdatedImages,
          activeTabIndex,
          tempTabIndexPolygone,
          setUpdatedTabIndexPolygone,
        })
      }
    >
      <div
        ref={containerRef}
        style={{
          position: 'absolute',
          left: polygone?.x ? polygone?.x + 'px' : '0',
          top: polygone?.y ? polygone?.y + 'px' : '0',
          width: polygone?.width,
          height: polygone?.height,
          resize: 'both',
          overflow: 'hidden',
          pointerEvents: 'auto',
          zIndex: polygone?.zIndex ? polygone?.zIndex : "1",
        }}
        className={styles.addImg}
        onContextMenu={(event) =>
          handleDeviceMenu(event, index, polygone, polygone?.deviceType, {
            id,
            setSelectedDeviceId,
            setDeviceMenuPosition,
            setClickedDeviceIndex,
            setIsDeviceMenu,
            setSelectedDevice,
            setCurrentDevice,
            tempImages,
            activeTabIndex,
            setTempImages,
            setUpdatedImages,
            setAddedText,
            setBgColor,
            setTextBgColor,
            setTextColor,
            setWidgetTextColor,
            setFontSize,
            setTextFontSize,
            setTextAlignVertically,
            setTextAlignHorizontally,
            tempTabIndexPolygone,
            updatedTabIndexPolygone,
            setUpdatedTabIndexPolygone,
            multiplePolygone,
            setMultiplePolygone,
          })
        }
      >
        <Stage
          width={size.width}
          height={size.height}
          style={{ width: '100%', height: '100%' }}
        >
          <Layer>
            <Line
              points={points}
              stroke="blue"
              fill={polygone?.bgColor ?? 'rgba(0, 0, 255, 0.3)'}
              strokeWidth={2}
              closed={true}
            />
          </Layer>
        </Stage>
      </div>
    </Draggable>
  );
}


export const TempGeneratePipe = ({
  tempTabIndexPipe,
  selectedTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  activeTabIndex,
  setUpdatedTabIndexPipe,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setIsDeviceMenu,
  setCurrentDevice,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexPipe,
  multiplePipe,
  setMultiplePipe,
  dashOffset,
  animationRef
}) => {
  const selectedTabImages = tempTabIndexPipe[selectedTabIndex];
  if (Array.isArray(selectedTabImages)) {
    return selectedTabImages.map((pipe, index) => {
      const { x, y, width, height, points, id, bgColor, textColor, zIndex } = pipe;
      const strokeOuter = 14;
      const strokeInner = 10;
      const strokeBorder = 17;
      const padding = strokeOuter;

      const paddedPoints = points.map((val, i) =>
        val + padding
      );

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, pipe?.x, pipe?.y, pipe?.deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              setUpdatedTabIndexPipe,
              tempTabIndexPipe,
            })
          }
        >
          <div
            style={{
              position: 'absolute',
              left: `${x - padding}px`, // shift left
              top: `${y - padding}px`,  // shift top
              width: `${Number(width) + padding * 2}px`, // extra padding
              height: `${Number(height) + padding * 2}px`,
              resize: 'both',
              overflow: 'visible',
              pointerEvents: 'auto',
              zIndex: zIndex ? zIndex : "1",
            }}
            className={styles.addImg}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, pipe, pipe?.deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setUpdatedTabIndexPipe,
                tempTabIndexPipe,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setIsDeviceMenu,
                setCurrentDevice,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexPipe,
                multiplePipe,
                setMultiplePipe,
              })
            }
          >
            <Stage
              width={Number(width) + padding * 2}
              height={Number(height) + padding * 2}
              style={{ width: '100%', height: '100%' }}
            >
              <Layer>
                {/* PIPE BORDER */}
                <Line
                  points={paddedPoints}
                  stroke="#444"                // 👈 black border
                  strokeWidth={strokeBorder}   // 👈 slightly bigger
                  lineCap="butt"
                  lineJoin="round"
                  shadowForStrokeEnabled={false}
                />

                <Line
                  points={paddedPoints}
                  stroke={bgColor || "#a8c4d9"}
                  strokeWidth={strokeOuter}
                  lineCap="butt"
                  lineJoin="round"
                  shadowForStrokeEnabled={false}
                />

              </Layer>
            </Stage>
          </div>
        </Draggable>
      );
    });
  }
}

export const TempGenerateSwitch = ({
  tempTabIndexSwitch,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexSwitch,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  switchRefs,
  dataArrLive
}) => {
  const selectedTabDevices = tempTabIndexSwitch[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, chartChannel, zIndex, bgColor } = device;

      let isOn = 0;
      if (chartChannel) {
        const matchedDatasets =
          chartChannel?.length === 0
            ? null
            : dataArrLive?.find(
              (dataset) => dataset.label === chartChannel[0]
            );

        const currentVal = matchedDatasets
          ? matchedDatasets?.data.slice(-1)
          : [0];
        if (currentVal && currentVal[0]) {
          isOn = parseInt(currentVal[0]) === 1 ? true : false
        }

      }

      const deviceStyle = {

        position: "absolute",
        left: x ? x + "px" : "0px",
        top: y ? y + "px" : "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "80px",
        height: "50px",
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexSwitch,
              setUpdatedTabIndexSwitch,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
              })
            }
            ref={(el) => (switchRefs.current[index] = el)}
            className={styles.addImg}
          //   onDoubleClick={(e) => handleDoubleClick(e, deviceType, id, on)}
          >
            <CustomSwitch
              on={isOn}
              bgColor={bgColor}
            />
          </div>
        </Draggable>
      );
    });
  }
};


export const TempGenerateCheckbox = ({
  tempTabIndexCheckbox,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexCheckbox,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  checkboxRefs,
  handleSelectCheckbox
}) => {
  const selectedTabDevices = tempTabIndexCheckbox[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, width, height, on, zIndex } = device;

      const deviceStyle = {

        position: "absolute",
        left: x ? x + "px" : "0px",
        top: y ? y + "px" : "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: width ? width : "15px",
        height: height ? height : "15px",
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexCheckbox,
              setUpdatedTabIndexCheckbox,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
              })
            }
            ref={(el) => (checkboxRefs.current[index] = el)}
            className={styles.addImg}
          //   onDoubleClick={(e) => handleDoubleClick(e, deviceType, id, on)}
          >
            <input type='checkbox' style={{ width: "100%", height: "100%" }} checked={on}
              onChange={() => handleSelectCheckbox(index)} />
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateRadio = ({
  tempTabIndexRadio,
  activeTabIndex,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexRadio,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  radioRefs,
  setUpdatedMultipleRadio,
  updatedMultipleRadio,
  updatedTabIndexRadio,
  handleSelectRadioButton
}) => {
  const selectedTabDevices = tempTabIndexRadio[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const { x, y, id, deviceType, width, height, zIndex } = device;
      const deviceStyle = {
        position: "absolute",
        left: x ? x + "px" : "0px",
        top: y ? y + "px" : "40px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "0.5rem",
        alignItems: "center",
        width: width ? width : "50px",
        height: height ? height : "50px",
        resize: "both",
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexRadio,
              setUpdatedTabIndexRadio,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                setUpdatedTabIndexRadio,
                tempTabIndexRadio,
                setUpdatedMultipleRadio,
                updatedMultipleRadio,
                updatedTabIndexRadio,
              })
            }
            ref={(el) => (radioRefs.current[index] = el)}
            className={styles.addImg}
            id={`radio-${index}`}
          >
            {device?.points.map((btn, i) => (
              <input
                type="radio"
                name={`group${index}`}
                style={{ flex: "1", width: "100%", cursor: "pointer" }}
                checked={device.selectedIndex === i}
                onChange={() => handleSelectRadioButton(i, deviceType)} />
            ))}
          </div>
        </Draggable>
      );
    });
  }
};

export const TempGenerateSlider = ({
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  tempTabIndexSlider,
  updatedTabIndexSlider,
  setUpdatedTabIndexSlider,
  multipleSlider,
  setMultipleSlider,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  sliderRefs,
  dateTimesLive,
  channelNames,
  dataArrLive,
}) => {
  const selectedTabDevices = tempTabIndexSlider[activeTabIndex];

  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const {
        x,
        y,
        id,
        deviceType,
        chartChannel,
        minVal,
        maxVal,
        width,
        bgColor,
        fontSize,
        textColor,
        zIndex,
      } = device;

      const deviceStyle = {
        position: "absolute",
        left: x ? x + "px" : "0px",
        top: y ? y + "px" : "40px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: width ? width : "190px",
        resize: 'both',
        zIndex: zIndex ? zIndex : "1",
        color: textColor ? textColor : "black"

      };


      let tranChartChannel = chartChannel && Array.isArray(chartChannel) ? chartChannel : [chartChannel];


      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexSlider,
              setUpdatedTabIndexSlider,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (sliderRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexSlider,
                updatedTabIndexSlider,
                setUpdatedTabIndexSlider,
                multipleSlider,
                setMultipleSlider,
              })
            }
            className={styles.addImg}
            id={`slider-${index}`}
          >
            <Slider
              minVal={minVal}
              maxVal={maxVal}
              chartChannel={tranChartChannel}
              dateTimesLive={dateTimesLive}
              dataArrLive={dataArrLive}
              bgColor={bgColor}
              fontSize={fontSize}
            />
          </div>
        </Draggable>
      );
    });
  }
};


export const TempGenerateLamp = ({
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  tempTabIndexLamp,
  updatedTabIndexLamp,
  setUpdatedTabIndexLamp,
  multipleLamp,
  setMultipleLamp,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  lampRefs,
  dateTimesLive,
  dataArrLive,

}) => {
  const selectedTabDevices = tempTabIndexLamp[activeTabIndex];

  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const {
        x,
        y,
        id,
        deviceType,
        chartChannel,
        width,
        height,
        zIndex
      } = device;



      const deviceStyle = {

        position: "absolute",
        left: x ? x : "0px",
        top: y ? y : "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: width ? width : "100px",
        height: height ? height : "100px",
        resize: "both",
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"

          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexLamp,
              setUpdatedTabIndexLamp,
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (lampRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexLamp,
                updatedTabIndexLamp,
                setUpdatedTabIndexLamp,
                multipleLamp,
                setMultipleLamp,
              })
            }
            className={styles.addImg}
            id={`lamp-${index}`}
          >
            <BulbIcon color='grey' />
          </div>
        </Draggable>
      );
    });
  }
};


export const TempGeneratePush = ({
  tempTabIndexPush,
  selectedTabIndex,
  pushRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexPush,
  setUpdatedTabIndexPush,
  multiplePush,
  setMultiplePush,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  handlePushBtnOn,
  setTempTabIndexPush
}) => {
  const selectedTabImages = tempTabIndexPush[selectedTabIndex];
  if (Array.isArray(selectedTabImages)) {
    return selectedTabImages.map((push, index) => {
      const { x, y, width, height, deviceType, id, zIndex } = push;

      const updatedDevice = updatedTabIndexPush[selectedTabIndex].find((item) => item.id === id);




      const deviceStyle = {
        width: width ? width : '100px',
        height: height ? height : '100px',
        position: 'absolute',
        left: x ? x : '0px',
        top: y ? y : '40px',
        border: '1px solid black',
        background: updatedDevice?.on === 1 ? "green" : 'red',
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        resize: "both",
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStart={() => handlePushBtnOn(index, push)}
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexPush,
              setUpdatedTabIndexPush,
              setTempTabIndexPush
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (pushRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, push, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexPush,
                updatedTabIndexPush,
                setUpdatedTabIndexPush,
                multiplePush,
                setMultiplePush,
              })
            }
            className={styles.addImg}
            id={`push-${index}`}

          >
            <span>{updatedDevice?.on === 1 ? "ON" : "OFF"}</span>
          </div>
        </Draggable>
      );
    });
  }
};


export const TempGenerateLink = ({
  tempTabIndexLink,
  activeTabIndex,
  isMobile,
  scaleValue,
  setClickedDeviceIndex,
  setSelectedDevice,
  tempImages,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempImages,
  setUpdatedImages,
  setUpdatedTabIndexLink,
  linkRefs,
  setIsDeviceMenu,
  setCurrentDevice,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexLink,
  multipleLink,
  setMultipleLink
}) => {
  const selectedTabDevices = tempTabIndexLink[activeTabIndex];
  if (Array.isArray(selectedTabDevices)) {
    return selectedTabDevices.map((device, index) => {
      const {
        x,
        y,
        id,
        deviceType,
        width,
        height,
        bgColor,
        textColor,
        text,
        fontSize,
        alignHorizontally,
        alignVertically,
        zIndex
      } = device;

      const deviceStyle = {
        position: 'absolute',
        top: y + 'px',
        left: x + 'px',
        backgroundColor: bgColor,
        color: textColor,
        padding: '0.6rem 1rem',
        fontSize: fontSize ? fontSize + 'px' : '30px',
        width: width ? width : undefined,
        height: height ? height : undefined,
        scale: isMobile ? scaleValue.toString() : '1',
        resize: 'both',
        display: 'flex',
        wordBreak: 'break-word',
        justifyContent: alignHorizontally ? alignHorizontally : 'start',
        alignItems: alignVertically ? alignVertically : 'start',
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              setUpdatedTabIndexLink,
              activeTabIndex,
              tempTabIndexLink,
            })
          }
        >
          <div
            style={deviceStyle}
            className={styles.addImg}
            ref={(el) => (linkRefs.current[index] = el)}
            key={index}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, device, deviceType, {
                id,
                bgColor,
                textColor,
                fontSize,
                text,
                alignVertically,
                alignHorizontally,
                setClickedDeviceIndex,
                setSelectedDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setIsDeviceMenu,
                setCurrentDevice,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                updatedTabIndexLink,
                multipleLink,
                setMultipleLink,
                tempTabIndexLink,
                setUpdatedTabIndexLink,
              })
            }
            id={`link-${index}`}
          >
            {text}
          </div>
        </Draggable>
      );
    });
  }
};


export const TempGenerateClock = ({
  tempTabIndexClock,
  selectedTabIndex,
  clockRefs,
  setSelectedDeviceId,
  setDeviceMenuPosition,
  setClickedDeviceIndex,
  setIsDeviceMenu,
  setSelectedDevice,
  setCurrentDevice,
  tempImages,
  activeTabIndex,
  setTempImages,
  setUpdatedImages,
  setAddedText,
  setBgColor,
  setTextBgColor,
  setTextColor,
  setWidgetTextColor,
  setFontSize,
  setTextFontSize,
  setTextAlignVertically,
  setTextAlignHorizontally,
  updatedTabIndexClock,
  setUpdatedTabIndexClock,
  multipleClock,
  setMultipleClock,
  updatedImages,
  setIndexesOfDevicePosi,
  indexesOfDevicePosi,
  setTempTabIndexClock
}) => {
  const selectedTabImages = tempTabIndexClock[selectedTabIndex];
  if (Array.isArray(selectedTabImages)) {
    return selectedTabImages.map((clock, index) => {
      const { x, y, width, height, deviceType, id, zIndex } = clock;

      const deviceStyle = {
        width: width ? width : "100px",
        height: height ? height : "100px",
        position: "absolute",
        left: x ? x + "px" : "0px",
        top: y ? y + "px" : "40px",
        background: "transparent",
        overflow: "hidden", // Prevent content overflow
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        resize: "both",
        zIndex: zIndex ? zIndex : "1",
      };

      return (
        <Draggable
          bounds="parent"
          onStop={(e, data) =>
            tempHandleDeviceDrop(e, data, index, id, x, y, deviceType, {
              setClickedDeviceIndex,
              setSelectedDevice,
              tempImages,
              updatedImages,
              setIndexesOfDevicePosi,
              indexesOfDevicePosi,
              setTempImages,
              setUpdatedImages,
              activeTabIndex,
              tempTabIndexClock,
              setUpdatedTabIndexClock,
              setTempTabIndexClock
            })
          }
        >
          <div
            style={deviceStyle}
            key={index}
            ref={(el) => (clockRefs.current[index] = el)}
            onContextMenu={(event) =>
              handleDeviceMenu(event, index, clock, deviceType, {
                id,
                setSelectedDeviceId,
                setDeviceMenuPosition,
                setClickedDeviceIndex,
                setIsDeviceMenu,
                setSelectedDevice,
                setCurrentDevice,
                tempImages,
                activeTabIndex,
                setTempImages,
                setUpdatedImages,
                setAddedText,
                setBgColor,
                setTextBgColor,
                setTextColor,
                setWidgetTextColor,
                setFontSize,
                setTextFontSize,
                setTextAlignVertically,
                setTextAlignHorizontally,
                tempTabIndexClock,
                updatedTabIndexClock,
                setUpdatedTabIndexClock,
                multipleClock,
                setMultipleClock,
              })
            }
            className={styles.addImg}
            id={`clock-${index}`}

          >
            <Clock />
          </div>
        </Draggable>
      );
    });
  }
};



